import React, { useEffect } from 'react';
import { useAtom } from 'jotai';
import { tasksAtom, fetchTasksAtom } from '../../../../atoms/v0/taskAtoms';
import { IOSSheet } from '../ios/IOSSheet';
import { TaskForm } from './TaskForm';
import { ImportanceCategory, TimeGroupCategory } from './DroppableArea';
import { CreateTaskData } from '../../../../types/task';
import { logger } from '../../../../lib/logger';

interface TaskDetailSheetProps {
  taskId?: string | null;
  projectId?: string | undefined;
  importance?: ImportanceCategory;
  timeGroup?: TimeGroupCategory;
  initialData?: Partial<CreateTaskData>; // 新增：初始数据
  isOpen: boolean;
  onClose: () => void;
}

/**
 * 任务详情浮层组件
 * 使用IOSSheet和TaskForm组件
 */
export const TaskDetailSheet: React.FC<TaskDetailSheetProps> = ({
  taskId,
  projectId,
  importance,
  timeGroup,
  initialData,
  isOpen,
  onClose
}) => {
  // 获取任务列表和刷新函数
  const [tasks] = useAtom(tasksAtom);
  const [, fetchTasks] = useAtom(fetchTasksAtom);

  // 当打开详情页且有taskId时，刷新任务列表以确保数据最新
  useEffect(() => {
    if (isOpen && taskId) {
      logger.info('TaskDetailSheet: Sheet opened with taskId, refreshing tasks', { taskId });
      fetchTasks();
    }
  }, [isOpen, taskId, fetchTasks]);

  // 创建一个引用，用于调用 TaskForm 的保存方法
  const formRef = React.useRef<{ handleSave: () => Promise<void> }>(null);

  // 处理保存
  const handleSave = () => {
    if (formRef.current) {
      formRef.current.handleSave();
    }
  };

  return (
    <IOSSheet
      isOpen={isOpen}
      onClose={onClose}
      title={taskId ? "任务详情" : "新建任务"}
      showCancelButton={true}
      showAddButton={true}
      onAdd={handleSave}
      data-task-detail-modal=""
    >
      <TaskForm
        taskId={taskId}
        projectId={projectId}
        importance={importance}
        timeGroup={timeGroup}
        initialData={initialData}
        onClose={onClose}
        ref={formRef}
        tasks={tasks}
      />
    </IOSSheet>
  );
};
